import { Component, OnInit } from '@angular/core';
import { WindowService } from '../window.service';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {
  projects = [
    { name: "Walk Talk", title: "Walk Talk", component: "walkTalk"},
    { name: "Being a Hater in a God Honoring Way", title: "Being a Hater in a God Honoring Way", component: "beingHater" },
    { name: "Let's Get Metaphysical", title: "Let's Get Metaphysical", component: "metaphysical" },
    { name: "30 Bananas a Day", title: "30 Bananas a Day", component: "bananas" },
    { name: "Postmodern Slime", title: "Postmodern Slime", component: "postmodernSlime" },
    { name: "The Pitch", title: "The Pitch", component: "thePitch" },
    { name: "Permanent Address", title: "Permanent Address", component: "permanentAddress" },
    { name: "Napkin Drawings", title: "Napkin Drawings", component: "napkinDrawings" },
    { name: "How to Save a Planet", title: "How to Save a Planet", component: "howTo" },
    { name: "Five Minute Crafts in the Age of Mechanical Reproduction", title: "Five Minute Crafts in the Age of Mechanical Reproduction", component: "fiveMinuteCrafts" },
    { name: "Everything is a Talk Show", title: "Everything is a Talk Show", component: "talkShow" }
  ]

  openWindows = [];
  
  constructor(private windowService: WindowService) { 
    this.windowService.windows$.subscribe(updatedWindows => {
      this.openWindows = updatedWindows;  // Update the local array whenever the service array changes
    });
  }

  openProject(project: string) {
    if (this.openWindows.findIndex(window => window.component === project) < 0) {
      const index = this.projects.findIndex(proj => proj.component === project);
      this.windowService.addWindow(this.projects[index]);
      setTimeout(() => {
        const openedWindow = document.getElementById(project);
        const left = 0.3*(window.innerWidth - openedWindow.getBoundingClientRect().width);
        const top = 0.3*(window.innerHeight - openedWindow.getBoundingClientRect().height);
        openedWindow.style.left = `${left}px`;
        openedWindow.style.top = `${top}px`;
        openedWindow.style.zIndex = `${this.windowService.getHighestZIndex()}`;
      }, 0.1);
    } else {
      const window = document.getElementById(project);
      setTimeout(() => {
        this.windowService.incrementHighestZIndex();
        window.style.zIndex = `${this.windowService.getHighestZIndex()}`;
      }, 0.1);
    }
  }

  // closeProject(project: string) {
  //   const index = this.openProjects.indexOf(project);
  //   if (index >= 0) {
  //     this.openProjects.splice(index, 1);
  //     this.openProjectsData.splice(index, 1);
  //   }
  // }

  ngOnInit(): void {
  }

}
